import React, { useEffect, useState } from 'react';
import { Icons, LONG_DAY_MONTH_YEAR_FORMAT, State } from '@model/common';
import styled from '@emotion/styled';
import { Snackbar } from '@components/common';
import { ThemeProps } from '@theme/base';
import { formatDate } from '@components/product/tour-pricing';
import { useI18NextContext } from '@components/hooks';

/* ***************** *
 *       Styles      *
 * ****************** */
const NoteContainer = styled(Snackbar)(({ theme }: ThemeProps) => ({
  margin: `${theme.custom.spacing.large}px 0`
}));

const NoteParagraph = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  margin: 0
}));

const Wrapper = styled.div({
  display: 'block',
  fontSize: '1.6rem'
});

export const AlternativeItineraryNote = () => {
  const t: any = useI18NextContext();
  const [alternativeDateParam, setAlternativeDateParam] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const dateParam = urlParams.get('alternativeDate');

      if (dateParam) {
        setAlternativeDateParam(dateParam);
      }
    }
  }, []);

  if (!alternativeDateParam) {
    return null;
  }

  const formattedDate = formatDate(alternativeDateParam, LONG_DAY_MONTH_YEAR_FORMAT);

  return (
    <NoteContainer
      icon={Icons.INFO}
      state={State.INFO}
      renderText={
        <Wrapper>
          <NoteParagraph>
            <strong>{t('common__label--alternative-itinerary')}</strong>
          </NoteParagraph>
          <NoteParagraph>
            {t('common__label--alternative-itinerary-note', { alternativeDate: formattedDate })}
          </NoteParagraph>
        </Wrapper>
      }
    />
  );
};
